import { z } from 'zod';

export const InwardTrackerBrandSummarySchema = z.array(
  z.object({
    brand: z.string(),
    brand_manager: z.string(),
    merch_portfolio: z.string(),
    dc_week: z.string(),
    dcs_raised: z.number(),
    dc_qty: z.number(),
    grned: z.number().nullable(),
    qc_failed: z.number().nullable(),
    qc_fail_pct: z.number().nullable(),
    allocations: z.number().nullable(),
    received: z.number().nullable(),
    fill_rate_pct: z.number().nullable(),
    styles_grned: z.number(),
    styles_live: z.number(),
    styles_grned_list: z.string(),
    styles_live_list: z.string(),
    pipeline_recv_pending: z.number(),
    pipeline_dc_pending: z.number(),
    pipeline_dc_incorrect: z.number(),
    pipeline_grn_pending: z.number(),
    pipeline_p0_failing: z.number(),
    pipeline_alloc_pending: z.number(),
    pipeline_scan_pending: z.number(),
    pipeline_dispatch_pending: z.number(),
    pipeline_in_transit: z.number(),
    pipeline_fully_rejected: z.number(),
    closed_without_grn: z.number(),
    stock_transfer_ids: z.string(),
  }),
);

export type InwardTrackerBrandSummary = z.infer<typeof InwardTrackerBrandSummarySchema>;

export const InwardTrackerItemSchema = z.array(
  z.object({
    brand: z.string().nullable(),
    brand_manager: z.string().nullable(),
    merch_portfolio: z.string().nullable(),
    dc_week: z.string(),
    dc_id: z.number(),
    unicom_po_code: z.string().nullable(),
    sku_code: z.string().nullable(),
    lk_style_number: z.string().nullable(),
    product_name: z.string().nullable(),
    category: z.string().nullable(),
    sub_category: z.string().nullable(),
    dc_status: z.string().nullable(),
    dc_created_on: z.string().nullable(),
    dc_arrived_on: z.string().nullable(),
    dc_ready_on: z.string().nullable().optional().transform(v => v ?? null),
    /* DC-header correction quantity (added 2026-05-27). Repeated across every
       item of a SENT_FOR_CORRECTION DC; downstream consumers must use it
       once per DC, not summed across items. */
    dc_total_correction_qty: z.coerce.number().optional().default(0),
    expected_delivery_date: z.string().nullable(),
    dc_item_qty: z.number(),
    grn_qty_received: z.number(),
    grn_qty_rejected: z.number(),
    grn_qty_accepted: z.number(),
    allocated_qty: z.number(),
    unallocated_qty: z.number(),
    received_qty: z.number(),
    in_transit_qty: z.number(),
    dispatch_pending_qty: z.number(),
    scan_pending_qty: z.number(),
    is_p0_failing: z.union([z.boolean(), z.number()]),
    highlight_status: z.string(),
  }),
);

export type InwardTrackerItem = z.infer<typeof InwardTrackerItemSchema>;

export const InwardTrackerStoreBreakdownSchema = z.array(
  z.object({
    brand: z.string(),
    dc_week: z.string(),
    store_name: z.string().nullable(),
    stock_transfer_id: z.number(),
    allocated_qty: z.number(),
    scanned_qty: z.number(),
    in_transit_qty: z.number(),
    received_qty: z.number(),
  }),
);

export type InwardTrackerStoreBreakdown = z.infer<typeof InwardTrackerStoreBreakdownSchema>;
